package com.flowyride.core.designsystem.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable

private val LightColors = lightColorScheme(
    primary = Orange40,
    onPrimary = Asphalt99,
    primaryContainer = Orange90,
    onPrimaryContainer = Orange10,
    secondary = Teal40,
    background = Asphalt99,
    surface = Asphalt99,
    surfaceVariant = Asphalt95,
    onSurface = Asphalt10,
)

private val DarkColors = darkColorScheme(
    primary = Orange80,
    onPrimary = Orange10,
    primaryContainer = Orange40,
    onPrimaryContainer = Orange90,
    secondary = Teal80,
    background = Asphalt10,
    surface = Asphalt10,
    surfaceVariant = Asphalt20,
    onSurface = Asphalt90,
)

@Composable
fun FlowyRideTheme(
    darkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit,
) {
    MaterialTheme(
        colorScheme = if (darkTheme) DarkColors else LightColors,
        content = content,
    )
}
